<!-- @deprecated - use design-system/atoms/SancareCheckbox.vue instead -->
<script setup lang="ts">
import { ref, watch } from 'vue'

interface Props {
  label?: string | null
  checked?: boolean
}

interface Emits {
  (event: 'change', value: boolean): void
}

const props = withDefaults(defineProps<Props>(), {
  label: null,
  checked: false
})

const emit = defineEmits<Emits>()

const value = ref<boolean>(props.checked)

watch(() => props.checked, (newChecked) => {
  value.value = newChecked
})

watch(value, (newValue) => {
  emit('change', newValue)
})

const toggle = (): void => {
  value.value = !value.value
}
</script>

<template>
  <div
    class="custom-checkbox"
    role="checkbox"
    @click.stop="toggle"
  >
    <svg
      class="custom-checkbox-svg"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="25"
      height="25"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="25 25 60 60"
    >
      <path
        d="M32.5,70h35c1.381,0,2.5-1.119,2.5-2.5v-35c0-1.381-1.119-2.5-2.5-2.5h-35c-1.381,0-2.5,1.119-2.5,2.5v35  C30,68.881,31.119,70,32.5,70z M35,35h30v30H35V35z"
        class="custom-checkbox-svg-box"
      />
      <path
        v-if="value"
        d="M56.982,42.607L47.5,52.089l-4.482-4.482c-0.976-0.977-2.56-0.977-3.535,0c-0.977,0.976-0.977,2.559,0,3.535l6.25,6.25  c0.488,0.488,1.128,0.732,1.768,0.732s1.28-0.244,1.768-0.732l11.25-11.25c0.977-0.976,0.977-2.559,0-3.535  C59.542,41.631,57.958,41.631,56.982,42.607z"
        class="custom-checkbox-svg-check"
      />
    </svg>
    <label
      v-if="label"
      class="custom-checkbox-label"
    >
      {{ label }}
    </label>
  </div>
</template>

<style lang="scss">
.custom-checkbox {
  display: inline-block;
  cursor: pointer;

  &:hover &-svg {
    opacity: .75;
  }

  &-svg {
    display: inline;
    transition: opacity .25s ease;
  }

  &-label {
    display: inline;
  }
}
</style>
